module.exports = __webpack_public_path__ + "static/img/thumb_4.67f0120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_4.png
// module id = +Pvu
// module chunks = 0